module.exports = __webpack_public_path__ + "media/react/app_submitter/components/PhotoReader/assets/switch-camera-805151b0d1c5b2101b1063cf750977d0.png";